/* globals window */

import dateScrollerEvents from '../events';

/**
 * Sets the initial date based on the available hash or today's date
 * @param {jQuery Element} $dateScrollerElement
 */
const setDateScrollerDate = ($dateScrollerElement) => {
  const hash = window.location.hash;
  let date;

  if (hash) {
    date = hash.substring(1);
  } else {
    const today = new Date();
    const monthPlus = today.getMonth() + 1;
    const month = monthPlus < 10 ? `0${monthPlus}` : monthPlus;

    date = `${today.getFullYear()}-${month}-${today.getDate()}`;
  }

  $dateScrollerElement.trigger(dateScrollerEvents.SET_DATE, { date });
};

export default setDateScrollerDate;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/dateScroller/utils/dateScrollerActions.js